import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import LangToggle from "./LangToggle";
import { useI18n } from "../context/I18nContext";

export default function Navbar({ settings }) {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();
  const links = [
    { to: "/", label: t("nav.home") },
    { to: "/services", label: t("nav.services") },
    { to: "/gallery", label: t("nav.gallery") },
    { to: "/about", label: t("nav.about") },
    { to: "/contact", label: t("nav.contact") },
  ];

  return (
    <header className="sticky top-0 z-50 bg-[#0A0B0E]/85 backdrop-blur border-b border-[#282C33]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="navbar-logo">
          {settings?.logo_url ? (
            <img src={settings.logo_url} alt="logo" className="h-8 w-8 object-cover" />
          ) : (
            <div className="h-8 w-8 bg-[#00A896] flex items-center justify-center">
              <span className="font-display font-black text-black text-lg">D</span>
            </div>
          )}
          <div className="leading-none">
            <div className="font-display font-black tracking-tight text-white text-lg uppercase">
              Diamondd <span className="text-[#00A896]">Traders</span>
            </div>
            <div className="text-[10px] font-mono text-[#8C939D] tracking-[0.3em] uppercase hidden sm:block">Chennai · Scrap Procurement</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-sm font-mono uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-[#00A896]" : "text-[#F3F4F6] hover:text-[#00A896]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <LangToggle />
          <a href={`tel:${settings?.mobile || ""}`} className="btn-primary text-xs" data-testid="navbar-call-btn">
            {t("nav.callNow")}
          </a>
        </nav>

        <div className="flex items-center gap-3 lg:hidden">
          <LangToggle />
          <button
            className="text-white"
            onClick={() => setOpen((o) => !o)}
            aria-label="menu"
            data-testid="navbar-mobile-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#282C33] bg-[#0A0B0E]" data-testid="navbar-mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-sm font-mono uppercase tracking-[0.2em] text-white hover:text-[#00A896]"
                data-testid={`nav-mobile-${l.to.replace("/", "") || "home"}`}
              >
                {l.label}
              </NavLink>
            ))}
            <a href={`tel:${settings?.mobile || ""}`} className="btn-primary text-xs w-fit">{t("nav.callNow")}</a>
          </div>
        </div>
      )}
    </header>
  );
}
